import axios from "../axios-private";

export function createSchedule(request) {
  return axios.post("/jadwal/insert", request);
}

export function setSchedule(request) {
  return axios.post("/jadwal/set", request);
}

export function cancelSchedule(request) {
  return axios.post("/jadwal/cancel", request);
}

export function removeSchedule(request) {
  return axios.post("jadwal/remove", request);
}

export function doneSchedule(request) {
  return axios.post("/jadwal/selesai", request);
}
